import React, { useContext, useEffect, useState } from "react";
import Courses from "./course";
import AddButton from "../../components/300/AddButton";
import { Box, Tab, Tabs } from "@mui/material";
import CurriculumList from "./curriculum";
import CourseContext from "../../context/CourseContext";
import useAuth from "../../hooks/useAuth";
import { useLocation } from "react-router-dom";
import useAxiosPrivate from "./../../hooks/useAxiosPrivate";
import CustomizedSnackbars from "./curriculum/CustomizedSnackbars";
// import api from "../../api/mainApi";

function CourseManagment() {
  const api = useAxiosPrivate();
  let location = useLocation();

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const [value, setValue] = React.useState("course");
  const { user } = useAuth();
  const courseContext = useContext(CourseContext);
  useEffect(() => {
    api
      .get("curriculum/curriculums")
      .then((curriculum) => {
        //console.log(curriculum.data.curriculums);
        console.log(JSON.stringify(curriculum.data, null, 2));

        courseContext.curriculumDispatch({
          type: "loadCurriculum",
          curriculums: curriculum.data.curriculums,
        });
      })
      .catch((err) => console.log(err));
    api
      .get("course/courses")
      .then((courses) => {
        console.log(JSON.stringify(courses.data, null, 2));
        courseContext.courseDispatch({
          type: "loadCourse",
          courses: courses.data.courses,
        });
      })
      .catch((err) => console.log(err));

    console.log("Curriculum state" + courseContext.curriculumState);
    console.log("Course state" + courseContext.courseState);
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      // alert(JSON.stringify(location.state, null, 2));
      setSnackBarOpen(location.state.open);
      setMessage(location.state.message);
    }
  }, []);
  return (
    //<Box
    //  sx={{
    //    display: "flex",
    //    flexDirection: "column",
    //    gap: "0.7rem",
    //    width: "100%",
    //  }}
    //>
    <>
      <Tabs
        value={courseContext.tabState}
        onChange={(event, newValue) => {
          courseContext.setTabState(newValue);
        }}
      >
        {user.roles.includes(351) && (
          <Tab label="Curriculum List" value={"curriculum"} />
        )}
        {user.roles.includes(301) && (
          <Tab label="Course List" value={"course"} />
        )}
      </Tabs>

      {user.roles.includes(courseContext.tabState === "course" ? 303 : 352) && (
        <AddButton
          link={
            courseContext.tabState === "course"
              ? { label: "Add Course", href: "/course_management/addCourse" }
              : {
                  label: "Add Curriculum",
                  href: "/course_management/addCurriculum",
                }
          }
        />
      )}
      {/*<Box>*/}
      {courseContext.tabState === "course" ? <Courses /> : <CurriculumList />}
      <CustomizedSnackbars
        {...{ setSnackBarOpen, snackBarOpen, message, overlay: true }}
      />
    </>
    //</Box>
    //</Box>
  );
}

export default CourseManagment;
